module.exports = __webpack_public_path__ + "static/media/opera-social-media-svgrepo-com.e836e90e.svg";